module.exports = __webpack_public_path__ + "img/share.9d436b7d.png";